<template>
        <div>
            <div>
                <span>Успешно склеено: </span>{{ successCount }}
            </div>
            <div>
                <span>Не склеено: </span>{{ errorsCount }}
            </div>
            <div v-for="error in errors">
                {{ error }}
            </div>
        </div>
</template>

<script>
export default {
    name: "AutoGlueSummary",
    props: {
        errors: { type: Array, required: true },
        successCount: { type: Number, required: true },
        errorsCount: { type: Number, required: true },
    }
}
</script>
